import React, { useEffect, useState } from 'react'
import PageTitleCard from '../cards/PageTitleCard'
import PageContainer from '../containers/PageContainer'
import { useTranslation } from 'react-i18next'
import CustomModal from '../common/CustomModal'
import { getCurrentSubscriptionPrices } from '../config/apiRoutes'
import useFetch from '../hooks/useFetch'
import SubScriptionSettings from '../subscription/SubScriptionSettings'
import CurrentSubscriptionCard from '../subscription/CurrentSubscriptionCard'
import { SubscriptionPlanPrice } from '../models/SubscriptionPlanPrice'
import TitleRestaurantSelector from '../common/TitleRestaurantSelector'
import SectionTitle from '../texts/SectionTitle'
import RestaurantSettings from '../restaurant/RestaurantSettings'
import PrimaryButton from '../buttons/PrimaryButton'
import AddIcon from '@mui/icons-material/Add';
import { Link } from 'react-router-dom'
import { newRestaurantRoute } from '../config/pageRoutes'
import SmallButton from '../buttons/SmallButton'

type Props = {}

const SettingsPage = (props: Props) => {
  const { t } = useTranslation();
  const [isSubModalOpen, setIsSubModalOpen] = useState(false);
  const [prices, setPrices] = useState<SubscriptionPlanPrice[]>([]);
  const priceCaller = useFetch();

  useEffect(() => {
    document.title = `QuickPick - ${t("navigation.settings")}`;
  }, [t("navigation.settings")]);

  useEffect(() => {
    fetchSubscriptionPlans();
  }, [])

  async function fetchSubscriptionPlans() {
    const response = await priceCaller.call<any, SubscriptionPlanPrice[]>("GET", getCurrentSubscriptionPrices);
    if (response.ok && response.data) {
      setPrices(response.data);
    }
  }

  return (
    <PageContainer>
      <PageTitleCard>
        <div className="flex justify-between">
          <div>
            <TitleRestaurantSelector />
          </div>
          <div className="">
            <Link to={newRestaurantRoute.path}>
              <SmallButton
                startIcon={<AddIcon style={{ marginTop: "-2px"}} />}
              >
                {t("common.create_restaurant")}
              </SmallButton>
            </Link>
          </div>
        </div>
      </PageTitleCard>
      <div className="mb-5">
        <div>
          <CurrentSubscriptionCard prices={prices} />
        </div>
        <CustomModal
          isOpen={isSubModalOpen}
          handleClose={() => setIsSubModalOpen(false)}
          minWidth='600px'
        >
          <SubScriptionSettings />
        </CustomModal>
        <div className="mt-5">
          <SectionTitle>
            {t("common.restaurant_settings")}
          </SectionTitle>
          <RestaurantSettings />
        </div>
        <CustomModal
          isOpen={isSubModalOpen}
          handleClose={() => setIsSubModalOpen(false)}
          minWidth='600px'
        >
          <SubScriptionSettings />
        </CustomModal>
      </div>

    </PageContainer >
  )
}

export default SettingsPage